<div class="loader" [class.full-height]="fullHeight">
  <div class="loading loading-{{ size }}"></div>
</div>
